import styled, { keyframes } from "styled-components";
import colors from "../../styles/colors";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const spinReverse = keyframes`
  0% { transform: rotate(360deg); }
  100% { transform: rotate(0deg); }
`;

export const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(11, 23, 42, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 99999999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const SpinnerRing = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3.5px solid transparent;
  border-top-color: ${colors.theme.yaelGreen};
  border-right-color: ${colors.theme.yaelOrange};
  animation: ${spin} 0.9s linear infinite;
  filter: drop-shadow(0 0 10px rgba(0, 167, 227, 0.6));
`;

export const SpinnerRingInner = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  right: 6px;
  bottom: 6px;
  border-radius: 50%;
  border: 3px solid transparent;
  border-bottom-color: ${colors.theme.yaelBlue};
  border-left-color: ${colors.theme.yaelGreen};
  animation: ${spinReverse} 1.3s linear infinite;
`;

export const LoadingText = styled.div`
  color: ${colors.theme.yaelWhite};
  font-size: 1.05rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-align: center;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
`;
